module.exports = __webpack_public_path__ + "static/sigma-4-59b04a193611128bcc1324071394e8d4.png";